import { Origin } from '~/constants';
import { LocalStorage } from '~/helpers';
import url from './url';
import request from './request';

const getHeaders = () => ({
  Authorization: `Bearer ${LocalStorage.getToken()}`,
  'Cache-Control': 'no-cache',
});

export const getLastCustomerMessageByAgent = async ({
  customerID,
  agentID,
}) => {
  const queryParams = new URLSearchParams({
    origin: Origin.CUSTOMER,
    agentID,
    limit: 1,
  });

  try {
    const { messages } = await request(
      `${url.messages}/${customerID}?${queryParams.toString()}`,
      {
        method: 'GET',
        headers: getHeaders(),
      }
    );

    return messages[0] ?? null;
  } catch (error) {
    return null;
  }
};

export const deleteMessage = async (messageID) => {
  await request(`${url.messages}/${messageID}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
};
